// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"2f5df03d","787":"0d390085"}[chunkId] + ".chunk.js";
};